import { useEffect } from 'react';

export default function MembershipPaywallModal() {
    useEffect(() => {
        document.body.classList.add('ai-consent-open');

        return () => {
            document.body.classList.remove('ai-consent-open');
        };
    }, []);

    return (
        <div className="chat-member-modal">
            <div className="chat-error modal-content">
                <h2>Atlas Membership Required</h2>
                <p>You must be an active Atlas Member to use the AI Assistant.</p>
                <div className='d-flex gap-2'>
                    <a href="/become-a-member/" className="custom-button">
                        Become a Member
                    </a>
                    <a href="/" className='custom-secondary-btn'>
                        Cancel
                    </a>
                </div>
            </div>
        </div>
    );
}